import React from 'react'
import { RowLayout } from '../RowLayout'
import { ClaimantDataType, CountryType } from '../../models'
import { translation } from '../../i18n'

export const ClaimantOverview = (
  params: {
    claimant?: ClaimantDataType
    countries: CountryType[]
  } & translation
) => {
  const t = params.t
  const isCompany = params.claimant?.claimantType === 'COMPANY'
  return (
    <>
      <RowLayout
        text={t('secondPg.claimantType.label')}
        data={t(`secondPg.claimantType.code.${isCompany ? 'COMPANY' : 'PERSON'}`)}
      />
      {isCompany ? (
        <>
          <RowLayout
            text={t('secondPg.companyName.label')}
            data={params.claimant?.company?.companyName}
          />
          <RowLayout
            text={t('secondPg.nip.label')}
            data={params.claimant?.company?.nip}
          />
        </>
      ) : (
        <>
          <RowLayout
            text={t('secondPg.firstName.label')}
            data={params.claimant?.person?.firstName}
          />
          <RowLayout
            text={t('secondPg.lastName.label')}
            data={params?.claimant?.person?.lastName}
          />
          {params.claimant?.nonResident ? (
            <RowLayout
              text={t('secondPg.nonResident.label')}
              data={!!params?.claimant?.nonResident ? t('yes') : t('no')}
            />
          ) : (
            <RowLayout
              text={t('secondPg.identification.label')}
              data={params?.claimant?.person?.idnum}
            />
          )}
        </>
      )}
      <RowLayout
        text={t('secondPg.email.label')}
        data={params?.claimant?.email}
      />
      <RowLayout
        text={t('secondPg.phone.label')}
        data={params?.claimant?.phone}
      />
      <RowLayout
        text={t('secondPg.street.label')}
        data={params?.claimant?.address?.street}
      />
      <RowLayout
        text={t('secondPg.zipCode.label')}
        data={params?.claimant?.address?.postCode}
      />
      <RowLayout
        text={t('secondPg.city.label')}
        data={params?.claimant?.address?.town}
      />

      <RowLayout
        text={t('secondPg.country.label')}
        data={
          params.countries.find(
            (item: CountryType) =>
              item.code === params?.claimant?.address?.country
          )?.name ?? params?.claimant?.address?.country
        }
      />
    </>
  )
}
